import React from 'react';
import { Flex } from '@edreamsodigeo/prisma-design-system';
import PersuasiveTags from '@components/Results/Components/ThreeColumnsItinerary/PersuasiveTags';
import LegList from '@components/Results/Components/ThreeColumnsItinerary/LegList';

export const LegLayout = ({
  withUKStyle,
  isAlternativeTopSection,
  isAlternativeItineraryOnModal,
  isAlternativeItinerary,
  legs,
  hasRetailingTechniques,
  itineraryId,
  isUnavailableItinerary,
  isSem,
}) => {
  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      justifyItems="center"
      flexGrow="2"
      sx={{
        ...((withUKStyle || isAlternativeTopSection) && {
          py: 'base',
          pl: 'base',
        }),
      }}
    >
      {!isAlternativeItineraryOnModal && (
        <PersuasiveTags
          hasRetailingTechniques={hasRetailingTechniques}
          itineraryId={itineraryId}
          isUnavailableItinerary={isUnavailableItinerary}
        />
      )}
      <Flex flexGrow="1" alignItems="center">
        <LegList
          legs={legs}
          isSem={isSem}
          isAlternativeItinerary={isAlternativeItinerary}
        />
      </Flex>
    </Flex>
  );
};
